export function init_variation(variation) {
  $('td.label', variation).append('<img src="/nsgk/wp-content/themes/nsgk/img/arrow_right.svg">');
  $('td.value', variation).prepend('<div class="options"></div>');

  $('td.value option', variation).each(function(){
    if ($(this).val().length > 0) {
      $('.options', variation).append('<div data-value="'+$(this).val()+'">'+$(this).text()+'</div>');
    }
  });

  $('td.label',variation).click(function() {
    if ($('td.value .options',variation).is(':visible')) {
      $('td.value .options',variation).slideUp();
      $('td.label img',variation).removeClass('open');
    } else {
      $('td.label img',variation).addClass('open');
      $('td.value .options',variation).slideDown();
    }
  });

  $('.options div',variation).click(function() {
    var value = $(this).attr('data-value');
    $('.options div',variation).removeClass('active');
    $('select',variation).val(value).change();
    $(this).addClass('active');

    var parent_tr = $(this).closest('tr');

    var price = $('.single_variation_wrap .woocommerce-variation-price').text();

    if (price.length > 0) {
      if ($('.product-price-custom').length > 0) {
        $('.product-price-custom').text(price);
      } else {
        $('.product-price').after('<div class="product-price-custom">'+price+'</div>');
      }
      $('.product-price').hide();
    }
    
    $('.variations tr').each(function() {   
      if ($(this).index() > $(parent_tr).index()) {
      var that = this; 
        $('.options div', this).each(function() {
          $('select', that).prop("selectedIndex", 0).val(); 
          var found = false;
          var current_option = $(this).attr('data-value');
          $('select option', that).each(function() {
            if (current_option && $(this).val() == current_option) {
              found = true;
            }
          });
          if (!found) {
            $(this).hide();
          } else {
            $(this).show();
          }
        });
      } 
    });
  });

  $('.reset_variations').click(function(){
    $('.options div').removeClass('active');
    $('.product-price').show();
    $('.product-price-custom').remove();
    $('.variations tr .options > div').show();
  });
}

// toggles "Fraktinfo"-information on productpage
export function init_product_info() {
  $('.single-product .columns h2').click(function(){
    var parent = $(this).parent();
    console.log('here');
    if ($('.tab-content',parent).length) {
      if ($(parent).hasClass('open')) {
        $(parent).removeClass('open');
        $('.tab-content',parent).slideUp();
      } else {
        $(parent).addClass('open');
        $('.tab-content',parent).slideDown();
      }
    }
  });

  if ($('.product .is-two-thirds > img').length) {
    var width = $('.product .is-two-thirds > img').width();
    $('.product .is-two-thirds > img').css('height', width);

    width = $('.product .is-two-thirds .columns img:first-child').width();
    $('.product .is-two-thirds .columns img:first-child').css('height', width);

    $(window).resize(function(){
      var width = $('.product .is-two-thirds > img').width();
      $('.product .is-two-thirds > img').css('height', width);

      width = $('.product .is-two-thirds .columns img:first-child').width();
      $('.product .is-two-thirds .columns img:first-child').css('height', width);
    })
  }

  if (window.location.href.indexOf('orderby=popularity') > -1) {
    $('.list-sort li[data-value="popularity"]').addClass('active');
  } else if (window.location.href.indexOf('orderby=date') > -1) {
    $('.list-sort li[data-value="date"]').addClass('active');
  } else if (window.location.href.indexOf('orderby=price') > -1) {
    $('.list-sort li[data-value="price"]').addClass('active');
  } else if (window.location.href.indexOf('orderby=price-desc') > -1) {
    $('.list-sort li[data-value="price-desc"]').addClass('active');
  }

  if (window.location.href.indexOf('product_tag=') > -1) {
    var current_tag = $('.custom-sort-form input[name="product_tag"]').val();
    var parent = $('.ewd-uwcf-filtering-checkbox[value="'+current_tag+'"]').parent();
    $(parent).addClass('active');
  }

  if ($('.ewd-uwcf-filters').length > 0 && $('.product').length < 1) {
    $('.ewd-uwcf-filters').hide();
  }

  $('.product-images .column img').click(function(){
    $('.product-images .column').removeClass('active');
    var parent = $(this).parent();
    $(parent).addClass('active');
    var new_image = $(this).attr('src');
    $('.product-images > img').attr('src', new_image);
  });

  $('#primary .product-info-tabs-tab',).click( function() {
    if($('#primary .product-info-tabs-tab .content').hasClass('open')) {
      $('#primary .product-info-tabs-tab .content').slideUp();
      $('#primary .product-info-tabs-tab .content').removeClass('open');
    } else {
      $('#primary .product-info-tabs-tab .content').slideDown();
      $('#primary .product-info-tabs-tab .content').addClass('open');
    }
  });
}

export function insert_extra_products_for_flex() {
  console.log('insert_extra_products_for_flex');
  if ($('.columns-4 .product').length > 0) {
    var left_to_add = $('.columns-4 .product').length % 4;
    console.log(left_to_add);
    for (var i = 0; i < left_to_add; i++) {
      $('.columns-4').append('<li style="visibility: hidden;" class="product type-product post-317 status-publish first instock product_cat-lektioner product_cat-medlemsskap product_tag-callaway has-post-thumbnail sale featured taxable shipping-taxable purchasable product-type-variable"></li>');
    }
  }
}

export function change_variation_image() {
  jQuery('.variations').on('click', '.options div', function() {
    var choice = jQuery(this).attr('data-value');
    var all_choices = [];
    jQuery('.variations tr').each(function(){
      if (jQuery('.options .active', this).length) {
        var filter_name = jQuery('select', this).attr('id');
        var filter_choice = jQuery('.options .active', this).attr('data-value');
        all_choices['attribute_' + filter_name] = filter_choice;
      }
    });
    //console.log(all_choices);
    var image_to_show = '';
    var variations = JSON.parse(jQuery(".variations_form").attr("data-product_variations"));
    var found = false;
    //console.log(choice, image_to_show, variations);
    for (const i in variations) {
      if (found) continue;
      if (variations.hasOwnProperty(i)) {
        var all_found = true;
        for (const [key, value] of Object.entries(variations[i].attributes)) {
          if (all_choices[key] === undefined || all_choices[key] != value) {
            all_found = false;
          }
        }
        if (all_found) {
          image_to_show = variations[i].image.full_src;
          if (image_to_show.length) {
            //console.log(image_to_show);
            found = true;
            jQuery(".product-images > img").attr("src", image_to_show).removeAttr("srcset"); 
          }
        }
      }
    }
  });
}
